var React = require('react');

function ArrowGreenInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-7.73014e-08 1.76845L7 8L14 1.76845L12.0135 -8.68338e-08L7 4.46442L1.98653 -5.25126e-07L-7.73014e-08 1.76845Z","fill":"#4CBAA6"}));
}

ArrowGreenInline.defaultProps = {"width":"14","height":"8","viewBox":"0 0 14 8","fill":"none"};

module.exports = ArrowGreenInline;

ArrowGreenInline.default = ArrowGreenInline;
